"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback, useMemo, useRef } from "react";
import { useDisclosure, useOutsideClick, Box } from "@chakra-ui/react";
import { DropdownMenu, DropdownMenuButton, DropdownMenuList, } from "../../atoms/DropdownMenu";
import { NavigationContext } from "./NavigationContext";
import NavigationHeaderItem from "./NavigationHeaderItem";
import { KeyboardCodes } from "../../helpers";
const getInitialContent = (children) => children;
const Navigation = ({ children, menuButtonProps, dropdownMenuProps, userName, variant, closeButtonLabel, }) => {
    const { onClose = () => { } } = dropdownMenuProps, otherDropdownMenuProps = __rest(dropdownMenuProps, ["onClose"]);
    const { isOpen, onClose: disclosureClose, onToggle } = useDisclosure();
    const menuRef = useRef(null);
    const [contentToDisplay, setContentToDisplay] = useState(getInitialContent(children));
    const [headerTitle, setHeaderTitle] = useState(userName);
    const resetContentToParent = useCallback(() => {
        setContentToDisplay(getInitialContent(children));
        setHeaderTitle(userName);
    }, [children, userName]);
    const navigationContextValue = useMemo(() => ({
        setContentToDisplay,
        resetContentToParent,
        closeMenu: disclosureClose,
        setHeaderTitle,
    }), [resetContentToParent, disclosureClose]);
    useOutsideClick({
        ref: menuRef,
        handler: () => {
            disclosureClose();
            resetContentToParent();
        },
    });
    return (_jsx(NavigationContext.Provider, Object.assign({ value: navigationContextValue }, { children: _jsx(DropdownMenu, Object.assign({ variant: "navigation", onClose: () => {
                resetContentToParent();
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }, isOpen: isOpen }, otherDropdownMenuProps, { children: _jsxs(Box, Object.assign({ ref: menuRef, onKeyDown: (e) => {
                    if (e.key === KeyboardCodes.ESCAPE &&
                        contentToDisplay === children) {
                        disclosureClose();
                    }
                } }, { children: [_jsx(DropdownMenuButton, Object.assign({}, menuButtonProps, { onClick: () => {
                            onToggle();
                        }, isOpen: isOpen, onKeyDown: (e) => {
                            if (e.key === KeyboardCodes.ENTER) {
                                onToggle();
                            }
                        } })), _jsxs(DropdownMenuList, { children: [_jsx(NavigationHeaderItem, { userName: userName, headerTitle: headerTitle, variant: variant, closeButtonLabel: closeButtonLabel }), contentToDisplay] })] })) })) })));
};
Navigation.displayName = "Navigation";
export default Navigation;
//# sourceMappingURL=Navigation.js.map